import React from 'react';
import { OfferTemplateConfig, TemplatePage } from '../../../../../types/offerTemplate.types';
import CoverPageRenderer from './CoverPageRenderer';
import ContentPageRenderer from './ContentPageRenderer';
import OfferPageRenderer from './OfferPageRenderer';

export interface PageRendererFactoryProps {
  page: TemplatePage;
  config: OfferTemplateConfig;
  offer?: any;
  offerType?: 'given' | 'received';
  companyInfo?: any;
}

const PageRendererFactory: React.FC<PageRendererFactoryProps> = ({
  page,
  config,
  offer,
  offerType,
  companyInfo,
}) => {
  switch (page.type) {
    case 'coverPage':
      return (
        <CoverPageRenderer
          page={page}
          config={config}
          offer={offer}
          offerType={offerType}
          companyInfo={companyInfo}
        />
      );
    case 'contentPage':
      return <ContentPageRenderer page={page} config={config} />;
    case 'offerPage':
      return (
        <OfferPageRenderer
          page={page}
          config={config}
          offer={offer}
          offerType={offerType}
          companyInfo={companyInfo}
        />
      );
    default:
      return null;
  }
};

export default PageRendererFactory;
